module.exports = __webpack_public_path__ + "static/media/open-source.386179b1.png";